import { CardBody } from "reactstrap";

const pct = (value) => Math.max(0, Math.min(100, Math.round(Number(value) || 0)));

export default function ShowTileCaptureLoader({ showLoader, uploaderTitle, uploadProgress }) {
  if (!showLoader) return null;

  const progress = pct(uploadProgress);
  const label = String(uploaderTitle || "Processing").replace(/:\s*$/, "");

  return (
    <CardBody style={{ paddingTop: 8, paddingBottom: 4 }}>
      <div
        style={{
          marginBottom: 14,
          padding: "14px 16px",
          borderRadius: 14,
          background: "linear-gradient(135deg, #0B1220 0%, #111827 45%, #0F172A 100%)",
          border: "1px solid rgba(96, 165, 250, 0.22)",
          boxShadow: "0 12px 32px rgba(2, 6, 23, 0.45), inset 0 1px 0 rgba(255,255,255,0.04)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
            gap: 12,
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "#E2E8F0",
              letterSpacing: "-0.01em",
              lineHeight: 1.35,
            }}
          >
            {label}
          </div>
          <div
            style={{
              flexShrink: 0,
              fontSize: 13,
              fontWeight: 700,
              fontVariantNumeric: "tabular-nums",
              background: "linear-gradient(90deg, #60A5FA, #2DD4BF)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}
          >
            {progress}%
          </div>
        </div>

        <div
          style={{
            position: "relative",
            height: 10,
            borderRadius: 999,
            overflow: "hidden",
            background: "rgba(148, 163, 184, 0.18)",
            boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.35)",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              height: "100%",
              width: `${progress}%`,
              borderRadius: 999,
              background: "linear-gradient(90deg, #1D4ED8 0%, #3B82F6 42%, #14B8A6 100%)",
              boxShadow: "0 0 16px rgba(59, 130, 246, 0.45)",
              transition: "width 280ms ease",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.35) 50%, transparent 100%)",
                backgroundSize: "200% 100%",
                animation: "tileUploadShimmer 1.4s ease-in-out infinite",
              }}
            />
          </div>
        </div>

        <div style={{ fontSize: 12.5, color: "#94A3B8", lineHeight: 1.45 }}>
          Large slides can take a few minutes. The viewer opens when all zoom levels are ready.
        </div>
      </div>

      <style>
        {`
          @keyframes tileUploadShimmer {
            0% { background-position: 200% 0; }
            100% { background-position: -200% 0; }
          }
        `}
      </style>
    </CardBody>
  );
}
